import React from "react";
import Logo from "../assets/images/logo.svg";

export default function AuthLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="min-h-screen flex items-center">
      <div className="w-[492px] mx-auto bg-white p-6 rounded-lg shadow-md">
        <div className="flex justify-center my-4">
          <img src={Logo} alt="Logo" />
        </div>
        {children}
      </div>
    </div>
  );
}
